// ======================================================================
// FILE:
// src/modules/expense_management/claims/utils/expenseClaimValidation.js
//
// MODULE:
// Expense Management
//
// FEATURE:
// Centralized Expense Claim Validation
// ======================================================================

function isBlank(value) {

    return (
        value === undefined ||
        value === null ||
        value === ""
    );

}

// ==========================================================
// HEADER
// ==========================================================

function validateHeader(header, errors) {

    if (isBlank(header.employee_id)) {
        errors.push("Employee is required.");
    }

    if (isBlank(header.expense_policy_id)) {
        errors.push("Expense Policy is required.");
    }

    if (isBlank(header.currency_id)) {
        errors.push("Currency is required.");
    }

    if (isBlank(header.claim_date)) {
        errors.push("Claim Date is required.");
    }

    if (isBlank(header.title)) {
        errors.push("Title is required.");
    }

}

// ==========================================================
// BUSINESS REFERENCE
// ==========================================================

function validateBusinessReference(header, errors) {

    if (
        !isBlank(header.expense_source) &&
        isBlank(header.reference_type)
    ) {

        errors.push(
            "Reference Type is required."
        );

    }

    if (
        !isBlank(header.reference_type) &&
        isBlank(header.reference_number)
    ) {

        errors.push(
            "Reference Number is required."
        );

    }

}

// ==========================================================
// EXPENSE ITEMS
// ==========================================================

function validateExpenseItems(
    items,
    header,
    errors
) {

    if (!items || items.length === 0) {

        errors.push(
            "At least one Expense Item is required."
        );

        return;

    }

    items.forEach((item, index) => {

        const row = index + 1;

        // --------------------------------------------------
        // Mandatory Fields
        // --------------------------------------------------

        if (isBlank(item.expense_category_id)) {

            errors.push(
                `Row ${row}: Expense Category is required.`
            );

        }

        if (isBlank(item.expense_type_id)) {

            errors.push(
                `Row ${row}: Expense Type is required.`
            );

        }

        if (isBlank(item.expense_date)) {

            errors.push(
                `Row ${row}: Expense Date is required.`
            );

        }

        if (
            Number(item.amount || 0) <= 0
        ) {

            errors.push(
                `Row ${row}: Amount must be greater than zero.`
            );

        }

        // --------------------------------------------------
        // PHASE 2 VALIDATIONS
        //
        // These validations automatically become active
        // once ExpenseItemsGrid starts sending these fields.
        // --------------------------------------------------

        // Line Currency

        if ("currency_id" in item) {

            if (
                isBlank(item.currency_id) &&
                isBlank(header.currency_id)
            ) {

                errors.push(
                    `Row ${row}: Currency is required.`
                );

            }

        }

        // Quantity

        if ("quantity" in item) {

            if (
                Number(item.quantity || 0) <= 0
            ) {

                errors.push(
                    `Row ${row}: Quantity must be greater than zero.`
                );

            }

        }

        // Unit Price / Rate

        if ("unit_price" in item) {

            if (
                Number(item.unit_price || 0) < 0
            ) {

                errors.push(
                    `Row ${row}: Unit Price cannot be negative.`
                );

            }

        }

    });

}

// ==========================================================
// ATTACHMENTS
// ==========================================================

function validateAttachments(
    attachments,
    header,
    items,
    errors
) {

    // ======================================================
    // PHASE 6
    //
    // Receipt validation based on Expense Policy
    // will be implemented here.
    // ======================================================

}

// ==========================================================
// EXPENSE CLAIM
// ==========================================================

export default function validateExpenseClaim({

    header,
    items,
    attachments,

}) {

    const errors = [];

    validateHeader(
        header,
        errors
    );

    validateBusinessReference(
        header,
        errors
    );

    validateExpenseItems(
        items,
        header,
        errors
    );

    validateAttachments(
        attachments,
        header,
        items,
        errors
    );

    return {

        isValid:
            errors.length === 0,

        errors,

    };

}